// extracted by mini-css-extract-plugin
export var content = "guidesPostPage-module--content--a7df1";